import TupUpWithBgIcon from './TupUpWithBgIcon'

export default TupUpWithBgIcon
